import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function GameRedirect() {
  const location = useLocation();

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const gameUrl = params.get("url");

  //   if (gameUrl) {
  //     setTimeout(() => {
  //       window.location.href = gameUrl;
  //     }, 900);
  //   }
  // }, [location.search]);

  useEffect(() => {
    const raw = location.search;
  
    if (raw.startsWith("?url=")) {
      // preserve everything after ?url=
      const fullUrl = raw.substring(5);
  
      // If URL was encoded, decode safely
      // const finalUrl = decodeURIComponent(fullUrl);
  
      setTimeout(() => {
        window.location.replace(fullUrl); // prevents history pollution
      }, 900);
    }
  }, [location.search]);

  return (
    <div className="loader-page">
      {/* LOGO */}
      <img
        src={process.env.REACT_APP_LOGO}
        alt="logo"
        className="logo"
      />

      {/* PREMIUM SPINNER */}
      <div className="loader">
        <div className="ring"></div>
        <div className="glow"></div>
      </div>

      <style>{`
        .loader-page {
          height: 100vh;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: radial-gradient(circle at center, #111 0%, #000 70%);
        }

        .logo {
          width: 300px;
          margin-bottom: 35px;
          animation: logoPulse 1.5s ease-in-out infinite alternate;
        }

        .loader {
          position: relative;
          width: 70px;
          height: 70px;
        }

        .ring {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 4px solid transparent;
          border-top: 4px solid #ff2a2a;
          border-right: 4px solid #ff5555;
          border-bottom: 4px solid #cc0000;
          animation: spin 0.9s linear infinite;
        }

        .glow {
          position: absolute;
          inset: 4px;
          border-radius: 50%;
          background: radial-gradient(circle,
            rgba(255,80,80,0.8) 0%,
            rgba(255,50,50,0.45) 40%,
            rgba(255,25,25,0.15) 65%,
            transparent 75%
          );
          animation: pulse 1.3s ease-in-out infinite;
          filter: blur(6px);
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        @keyframes pulse {
          0%, 100% { transform: scale(0.9); opacity: .65; }
          50% { transform: scale(1.15); opacity: 1; }
        }

        @keyframes logoPulse {
          from { transform: scale(1); }
          to { transform: scale(1.05); }
        }

        @media (max-width: 600px) {
          .logo {
            width: 140px;
            margin-bottom: 25px;
          }
          .loader {
            width: 52px;
            height: 52px;
          }
        }
      `}</style>
    </div>
  );
}
